// Подписи месяцев для хода строительства.
// Intl отдаёт «август 2026 г.», а в макете «Август 2026» — поэтому собираем строку сами.
const MONTHS = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

/**
 * Ссылка на трансляцию, если по ней вообще можно перейти.
 *
 * В базе у домов встречается заглушка «#» — с ней кнопка рисовалась, но никуда
 * не вела. Пустую строку и якорь считаем отсутствием ссылки, иначе на странице
 * появляется заведомо мёртвая кнопка.
 */
export function usableStreamLink(link: string | null | undefined): string {
  const value = (link || "").trim();
  if (!value || value === "#" || value.startsWith("#")) return "";
  return value;
}

/**
 * Карточка с готовностью дома нужна, только если есть что показать:
 * процент готовности (и он не скрыт в админке) либо рабочая ссылка на трансляцию.
 */
export function hasConstructionSummary(
  house: { progress_amount?: number | null; stream_link?: string | null } | null | undefined,
  hideProgress?: boolean,
): boolean {
  if (!house) return false;

  const hasProgress = !hideProgress && house.progress_amount !== null && house.progress_amount !== undefined;

  return hasProgress || Boolean(usableStreamLink(house.stream_link));
}

/**
 * Порядок вкладок домов: сначала дома с порядком из админки по возрастанию,
 * следом остальные — от самого готового к самому раннему.
 */
export function compareConstructionHouses(
  a: { construction_progress_order?: number | null; progress_amount?: number | null },
  b: { construction_progress_order?: number | null; progress_amount?: number | null },
): number {
  const orderA = a.construction_progress_order ?? Infinity;
  const orderB = b.construction_progress_order ?? Infinity;

  if (orderA !== orderB) return orderA < orderB ? -1 : 1;

  return (b.progress_amount ?? 0) - (a.progress_amount ?? 0);
}

export function formatConstructionMonth(date: string | undefined | null): string {
  if (!date) return "";

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "";

  return `${MONTHS[parsed.getMonth()]} ${parsed.getFullYear()}`;
}
